.review {
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  border-radius: 1.5rem;
  background-color: var(--neutral);
  box-shadow: 0 1.875rem 3.75rem -1.25rem rgba(0, 0, 0, 0.4);

  .user {
    display: flex;
    align-items: center;
    margin: 0 0 1rem;

    .stars {
      display: flex;
      column-gap: 0.125rem;
    }

    .letter {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 2rem;
      height: 2rem;
      margin: 0 0.75rem 0 0;
      border-radius: 2rem;
      font-size: 1rem;
      line-height: 100%;
      background-color: var(--primary-200);
    }
  }

  .name {
    margin: 0 0 0.5rem;
    font-weight: 600;
    font-size: 1.1875rem;
  }

  .description {
    display: block;
    font-size: 1.125rem;
    line-height: 150%;
  }
}
